import { defineComponent as _defineComponent } from 'vue'
import BlogSectionSimpleItem from './BlogSectionSimpleItem.vue';
import { type TextAlign } from '../../../../types';

interface Props {
  items: {
    image?: {
      src?: string | null;
      alt?: string | null;
    } | null;
    title: string;
    link?: string | null;
    tags?: string[] | null;
    contentAlign?: TextAlign | null;
    creative_name?: string | null;
  }[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BlogSectionSimpleGrid',
  props: {
    items: null
  },
  emits: ["item-click"],
  setup(__props: any, { emit }: { emit: ({ (e: 'item-click', index: number): void }), expose: any, slots: any, attrs: any }) {




const onItemClick = (index: number) => {
  emit('item-click', index);
};

return { __sfc: true,emit, onItemClick, BlogSectionSimpleItem }
}

})